module.exports = __webpack_public_path__ + "static/media/petImage.d56ac3b5.jpg";